import { DBSystemCode } from '@home/_config/config';

import type { IAISearchPageSupportConfig } from '@home/types/aiSearch';

const AI_SEARCH_PAGE_SUPPORT_CONFIG: IAISearchPageSupportConfig = {
  system: DBSystemCode.Intelligence,
  mode: 'whitelist',
  routes: [
    {
      matchType: 'exact',
      pathname: '/intelligence/topCharts/mobileGames/ActiveUsers',
    },
    {
      matchType: 'exact',
      pathname: '/intelligence/topCharts/mobileGames/Revenue',
    },
    {
      matchType: 'exact',
      pathname: '/intelligence/topCharts/mobileGames/Downloads',
    },
    {
      matchType: 'exact',
      pathname: '/intelligence/topCharts/mobileGames/DataBrainCalibration',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/mobileGames/gamesDetails/:id/overview',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/mobileGames/gamesDetails/:id/stats/:segment',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/mobileGames/gamesDetails/:id/countries/:segment',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/pcConsoleGames/:tab',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/pcConsoleGames/gamesDetails/:id/stats',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/pcConsoleGames/gamesDetails/:id/originalStats/:segment',
    },
    {
      matchType: 'template',
      pathname: '/intelligence/topCharts/pcConsoleGames/gamesDetails/:id/countries/:segment',
    },
  ],
};

export default AI_SEARCH_PAGE_SUPPORT_CONFIG;
